import React, { useState } from 'react';
import { Box, Typography, Button, Tooltip, Paper } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StreakBackfillDialog from './StreakBackfillDialog';

export default function StreakWidget({ stats, heatmapData = [], onRefresh }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const { currentStreak = 0, longestStreak = 0, streakIsAlive = false, lastBackfillUsed } = stats || {};

  const canBackfill = !lastBackfillUsed || (() => {
    const daysSince = Math.round((Date.now() - new Date(lastBackfillUsed).getTime()) / 86400000);
    return daysSince >= 30;
  })();

  const backfillTooltip = canBackfill
    ? 'Retroactively count a day you forgot to log activity'
    : 'Backfill used recently — available again in a few weeks';

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ textAlign: 'center' }}>
            <LocalFireDepartmentIcon color={streakIsAlive ? 'error' : 'disabled'} sx={{ fontSize: 36 }} />
            <Typography variant="h5" fontWeight="bold">{streakIsAlive ? currentStreak : 0}</Typography>
            <Typography variant="caption" color="text.secondary">Current streak</Typography>
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <EmojiEventsIcon color="warning" sx={{ fontSize: 36 }} />
            <Typography variant="h5" fontWeight="bold">{longestStreak}</Typography>
            <Typography variant="caption" color="text.secondary">Best streak</Typography>
          </Box>
          {!streakIsAlive && currentStreak === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 200 }}>
              Add something to your collection today to start a streak!
            </Typography>
          )}
        </Box>
        <Tooltip title={backfillTooltip}>
          <span>
            <Button
              size="small"
              variant="outlined"
              disabled={!canBackfill}
              onClick={() => setDialogOpen(true)}
            >
              Backfill a missed day
            </Button>
          </span>
        </Tooltip>
      </Box>

      <StreakBackfillDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        heatmapData={heatmapData}
        onSuccess={onRefresh}
      />
    </Paper>
  );
}
